<div class="route-component">
    <wizard-control [activeTabIndex]="activeTabIndex" (onFinished)="finished()" (cancel)="onCancel()">
        <wizard-step  title="Auto-Match" [valid]="isAutoMatchValid()" [wizardStepInstance]="autoMatchComponent">
            <matching-auto-match #autoMatchComponent />
        </wizard-step>

        <wizard-step  title="Records" [valid]="isRecordsValid()" [wizardStepInstance]="recordsComponent">
            <matching-records #recordsComponent />
        </wizard-step>

        <wizard-step title="Summary" [allowPrevious]="false">
            <h4>
                Done!
            </h4>
            <p>
                Matched succesfully, click Finish to mark as Complete
            </p>
        </wizard-step>
    </wizard-control>
</div>